module.exports = __webpack_public_path__ + "static/media/mitra.3a167ab8.jpg";